import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionSupervisorDto } from './subdivision-supervisor.dto';
import { SubdivisionSupervisorUpdatableInterface } from '../interfaces/subdivision-supervisor-updatable.interface';

export class SubdivisionSupervisorUpdateDto
  extends PartialType(
    PickType(SubdivisionSupervisorDto, ['userId', 'subdivisionId']),
  )
  implements SubdivisionSupervisorUpdatableInterface {}
